<div #pdfArea class="doc">
  <!-- PÁGINA 1 -->
  <section class="page">
    <!-- <header class="brand">
        <div class="logo">
          <img #pdfImageLogo class="logo-img" [src]="logoUrl" alt="Logo" />
        </div>
      </header> -->

    <h1 class="headline" [innerHTML]="currentTemplate?.cover?.title"></h1>
    <p class="subhead" [innerHTML]="currentTemplate?.cover?.description"></p>

    <h2 class="hello">Olá, {{ currentTemplate?.welcome?.fullName }}</h2>
    <div class="intro">
      <p [innerHTML]="currentTemplate?.welcome?.description"></p>
    </div>

    <h3 class="section-title">Proposta</h3>
    <div class="grid">
      <div class="card no-border">
        <div class="label"><strong>Nome</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.welcome?.fullName"></div>
      </div>
      <div class="card no-border">
        <div class="label"><strong>Empresa</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.company"></div>
      </div>
      <div class="card no-border">
        <div class="label"><strong>Cargo</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.position"></div>
      </div>
      <div class="card no-border">
        <div class="label">
          <strong>{{ currentTemplate?.offerDetails?.salaryType === 'horista' ? 'Salário por Hora' : 'Salário' }}</strong>
        </div>
        <div
          class="value"
          [innerHTML]="getCurrencyHelper(currentTemplate?.offerDetails?.wage) + (currentTemplate?.offerDetails?.salaryType === 'horista' ? '/hora' : '')"
        ></div>
        <div
          class="obs"
          [innerHTML]="currentTemplate?.offerDetails?.wageSubtitle"
        ></div>
      </div>
      <div class="card no-border" *ngIf="currentTemplate?.offerDetails?.showVariableWage">
        <div class="label"><strong>Remuneração variável</strong></div>
        <div
          class="value"
          [innerHTML]="currentTemplate?.offerDetails?.variableWage"
        ></div>
        <div
          class="obs"
          [innerHTML]="currentTemplate?.offerDetails?.variableWageSubtitle"
        ></div>
      </div>
      <div class="card no-border" *ngIf="currentTemplate?.offerDetails?.grupoSalarialName">
        <div class="label"><strong>{{ currentTemplate?.offerDetails?.grupoSalarialLabel }}</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.grupoSalarialName"></div>
      </div>
      <div class="card no-border" *ngIf="currentTemplate?.offerDetails?.workload">
        <div class="label"><strong>Carga horária</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.workload"></div>
      </div>
      <div class="card no-border" *ngIf="currentTemplate?.offerDetails?.workSchedule">
        <div class="label"><strong>Escala de trabalho</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.workSchedule"></div>
      </div>
      <div class="card no-border" *ngIf="currentTemplate?.offerDetails?.workHours">
        <div class="label"><strong>Jornada de trabalho</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.workHours"></div>
      </div>
      <div class="card no-border" *ngIf="currentTemplate?.offerDetails?.baseDate">
        <div class="label"><strong>Data-base</strong></div>
        <div class="value-text" [innerHTML]="currentTemplate?.offerDetails?.baseDate"></div>
      </div>
      <div class="card no-border" *ngFor="let item of currentTemplate?.offerDetails?.remuneracaoExtra">
        <div class="label"><strong [innerHTML]="item.title"></strong></div>
        <div class="value-text" [innerHTML]="item.description"></div>
      </div>
    </div>

    <h3
      class="section-title-secondary"
      *ngIf="
        currentTemplate?.offerDetails?.secondaryCall &&
        ((currentTemplate?.offerDetails?.variableWage_2 &&
          currentTemplate?.offerDetails?.iLP) ||
          (currentTemplate?.offerDetails?.variableWage_2 &&
            currentTemplate?.offerDetails?.iLP))
      "
      [innerHTML]="currentTemplate?.offerDetails?.secondaryCall"
    ></h3>

    <div
      class="list"
      *ngIf="
        currentTemplate?.offerDetails?.hasILP ||
        currentTemplate?.offerDetails?.hasHiringBonus
      "
    >
      <div
        class="item"
        *ngIf="
          currentTemplate?.offerDetails?.hasHiringBonus &&
          currentTemplate?.offerDetails?.hiringBonus
        "
      >
        <div class="item-title">
          {{ currentTemplate?.offerDetails?.variableWage_1 }}
        </div>
        <div
          class="item-text"
          [innerHTML]="currentTemplate?.offerDetails?.hiringBonus"
        ></div>
      </div>
      <div
        class="item"
        *ngIf="
          currentTemplate?.offerDetails?.hasILP &&
          currentTemplate?.offerDetails?.iLP
        "
      >
        <div class="item-title">
          {{ currentTemplate?.offerDetails?.variableWage_2 }}
        </div>
        <div
          class="item-text"
          [innerHTML]="currentTemplate?.offerDetails?.iLP"
        ></div>
      </div>
    </div>

    <h3 class="section-title-secondary">Informações adicionais</h3>
    <div class="info">
      <div *ngIf="currentTemplate?.offerDetails?.managerName">
        <span class="k">Gestor: </span>
        <span [innerHTML]="currentTemplate?.offerDetails?.managerName"></span>
      </div>
      <div *ngIf="currentTemplate?.offerDetails?.workModel">
        <span class="k">Modelo de trabalho: </span>
        <span [innerHTML]="currentTemplate?.offerDetails?.workModel"></span>
      </div>
      <div *ngIf="currentTemplate?.offerDetails?.workSite">
        <span class="k">Local de Trabalho: </span>
        <span [innerHTML]="currentTemplate?.offerDetails?.workSite"></span>
      </div>
      <div *ngIf="currentTemplate?.offerDetails?.admissionDate">
        <span class="k">Data de admissão prevista: </span>
        <span [innerHTML]="currentTemplate?.offerDetails?.admissionDate"></span>
      </div>
    </div>

    <div class="footnote" *ngIf="currentTemplate?.offerDetails?.note">
      <p
        class="footnote-text"
        [innerHTML]="currentTemplate?.offerDetails?.note"
      ></p>
    </div>

    <h3
      class="section-title"
      [innerHTML]="currentTemplate?.benefits?.title"
    ></h3>
    <p
      class="footnote-text"
      [innerHTML]="currentTemplate?.benefits?.description"
    ></p>

    <ng-container *ngIf="currentTemplate?.benefits?.hasCustomOrder; else gruposBenesTpl">
      <div class="list">
        <div class="item" *ngFor="let bene of currentTemplate?.benefits?.benesList">
          <div class="item-title" [innerHTML]="bene.name"></div>
          <div class="item-text" [innerHTML]="bene.description"></div>
        </div>
      </div>
    </ng-container>
    <ng-template #gruposBenesTpl>
      <div *ngFor="let grupo of currentTemplate?.benefits?.gruposBenes">
        <h3 class="section-title-secondary" [innerHTML]="grupo.title"></h3>
        <p [innerHTML]="grupo.description"></p>
        <div class="list">
          <div class="item" *ngFor="let bene of grupo.benes">
            <div class="item-title" [innerHTML]="bene.name"></div>
            <div class="item-text" [innerHTML]="bene.description"></div>
          </div>
        </div>
      </div>
    </ng-template>
  </section>

  <section class="page">
    <!-- <header class="brand small-gap">
        <div class="logo">
          <img class="logo-img" [src]="logoUrl" alt="Logo" />
        </div>
      </header> -->

    <ng-container
      *ngIf="
        propostaSalarial?.status === coStatusConstants.ACEITO ||
        propostaSalarial?.status === coStatusConstants.RECUSADO
      "
    >
      <hr class="divider" />

      <h3 class="section-title status">Status da oferta</h3>
      <p
        class="muted"
        *ngIf="
          propostaSalarial?.status === coStatusConstants.ACEITO &&
          !shouldShowDigitalAcceptanceCard
        "
      >
        Proposta aceita
        <ng-container>
          em
          {{
            currentTemplate?.acceptanceDataWithoutFlag?.acceptedAtWithoutFlag
              | date : "dd/MM/yy"
          }}
          às
          {{
            currentTemplate?.acceptanceDataWithoutFlag?.acceptedAtWithoutFlag
              | date : "HH:mm"
          }}
        </ng-container>
      </p>

      <p
        class="muted"
        *ngIf="
          propostaSalarial?.status === coStatusConstants.ACEITO &&
          currentTemplate?.acceptanceData?.acceptedAt
        "
      >
        Proposta aceita
        <ng-container>
          em
          {{ currentTemplate?.acceptanceData?.acceptedAt | date : "dd/MM/yy" }} às
          {{ currentTemplate?.acceptanceData?.acceptedAt | date : "HH:mm" }}
        </ng-container>
      </p>

      <p
        class="muted"
        *ngIf="propostaSalarial?.status === coStatusConstants.RECUSADO"
      >
        Proposta negada
        <ng-container>
          em
          {{ currentTemplate?.rejectionData?.rejectedAt | date : "dd/MM/yy" }} às
          {{ currentTemplate?.rejectionData?.rejectedAt | date : "HH:mm" }}
        </ng-container>
      </p>
    </ng-container>

    <hr-digital-acceptance-card
      *ngIf="shouldShowDigitalAcceptanceCard && acceptanceData"
      [fullName]="currentTemplate?.welcome?.fullName"
      [dataAceite]="currentTemplate?.acceptanceData?.acceptedAt"
      [ipAssinante]="currentTemplate?.acceptanceData?.ipAddress"
      [acceptanceCardAppeareance]="acceptanceCardAppeareance"
    ></hr-digital-acceptance-card>
  </section>
</div>
